<ae-map-engine (mapUpdated)="onMapUpdated($event)"
               [initialIndex]="initialIndex"
               [mapOperationMode]="mapOperationMode"
               [maps]="maps"
               (newInspectionSelected)="onInspectionSelected($event)"
               [inspectionList]="inspectionList">
</ae-map-engine>
